import React, { useState } from 'react';

const subjectsList = ['English 9', 'English 10', 'Creative Writing', 'AP Lang', 'Algebra 1', 'Algebra 2', 'H Algebra 2', 'Geometry', 'Pre-Calc', 'H Pre-Calc', 'AP Calculus AB', 'AP Statistic', 'Biology', 'Chemistry', 'Chemistry H', 'Chemistry AP', 'Physics', 'AP Environmental Science', 'AP Computer Science', 'US History', 'AP US History', 'AP Euro', 'AP Human Geography', 'World History', 'MUN', 'AP Psychology', 'Spanish', 'AP Spanish', 'French', 'MS English', 'MS Math', 'MS Pre-Algebra', 'MS Algebra', 'MS Biology', 'MS History', 'MS Spanish', 'Elementary School', 'ANATMY 1: General Human Anatomy', 'ART 34A: New Genres', 'AHIS 1: Western Art Hist 1', 'BUS 1: Business Intro', 'CHNESE 1: Elementary Chinese 1', 'COMM C1000: Introduction to Public Speaking', 'CS 3: Introduction to Computer Science', 'CS 50: C Programming', 'CS 17: Assembly Language', 'CS 79D: Security in AWS', 'CS 79F: Machine Learning in AWS', 'CS 87A: Python Programming', 'CS 52: C++ Programming', 'COUNS 20 - Stdnt Success', 'ECON 1: Principles of Microeconomics', 'Eng 1: Reading and Composition', 'Eng 2: Critical Analysis and Composition', 'ENGL C1000:Academic Reading and Writing', 'HEALTH 11: First Aid and CPR', 'KIN PE 58B: Interm Yoga', 'Math 2: Precalculus', 'Math 6: MODERN MATH STEM', 'Math 7: Calculus 1', 'Psych 1: General Psychology', 'PHILOS 7: Logic and Critical Thinking', 'Th art 20: Stagecraft', 'Th art 22: Stage Lighting', 'Th art 23: Lighting and Projection', 'Th art 25: Theatrical Sound', 'Th art 31: Stage Management'];



export default function EditDialog({ open, type, data, onSave, onClose }) {
  const [form, setForm] = useState(data || {});
  React.useEffect(() => {
    setForm(data || {});
  }, [data, open]);
  if (!open) return null;

  function handleChange(e) {
    const { name, value, type: inputType, checked } = e.target;
    if (name === 'subjects') {
      let current = Array.isArray(form.subjects) ? form.subjects : [];
      if (checked) {
        setForm({ ...form, subjects: [...current, value] });
      } else {
        setForm({ ...form, subjects: current.filter(s => s !== value) });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  }
  function handleSubmit(e) {
    e.preventDefault();
    onSave(form);
  }
  return (
    <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.3)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
      <form onSubmit={handleSubmit} style={{background:'#fff',padding:24,borderRadius:8,minWidth:300}}>
        <h3>Edit {type === 'tutor' ? 'Tutor' : 'Student'}</h3>
        {type === 'tutor' ? (
          <>
            <input name="firstName" value={form.firstName||''} onChange={handleChange} placeholder="First Name" required style={{marginBottom:8}}/><br/>
            <input name="lastName" value={form.lastName||''} onChange={handleChange} placeholder="Last Name" required style={{marginBottom:8}}/><br/>
            <input name="email" value={form.email||''} onChange={handleChange} placeholder="Email" required style={{marginBottom:8}}/><br/>
            <input name="school" value={form.school||''} onChange={handleChange} placeholder="School" style={{marginBottom:8}}/><br/>
            <input name="schoolEmail" value={form.schoolEmail||''} onChange={handleChange} placeholder="School Email" required style={{marginBottom:8}}/><br/>
            <div style={{marginBottom:8}}>
              <label>Graduation Year:<br/>
                <select name="gradYear" value={form.gradYear||''} onChange={handleChange} required style={{width:'100%',marginTop:4}}>
                  <option value="">Select Year</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                </select>
              </label>
            </div>
            <div style={{marginBottom:8}}>
              <label>Subjects:<br/>
            <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '8px',
                  marginTop: 4,
                  maxWidth: '100%',
                  alignItems: 'flex-start'
                }}>
                  {subjectsList.map(s => (
                    <label key={s} style={{
                      marginRight: '8px',
                      marginBottom: '4px',
                      whiteSpace: 'nowrap',
                      fontSize: '14px'
                    }}>
                      <input type="checkbox" name="subjects" value={s} checked={Array.isArray(form.subjects) && form.subjects.includes(s)} onChange={handleChange} /> {s}
                    </label>
                  ))}
                </div>
              </label>
            </div>
            <input name="time" value={form.time||''} onChange={handleChange} placeholder="Time" style={{marginBottom:8}}/><br/>
            <input name="gender" value={form.gender||''} onChange={handleChange} placeholder="Gender" style={{marginBottom:8}}/><br/>
            <input name="csf" value={form.csf||''} onChange={handleChange} placeholder="CSF" style={{marginBottom:8}}/><br/>
            <input name="comments" value={form.comments||''} onChange={handleChange} placeholder="Comments" style={{marginBottom:8}}/><br/>
            <input name="bookingLink" value={form.bookingLink||''} onChange={handleChange} placeholder="Booking Link (WordPress URL)" style={{marginBottom:8}}/><br/>
            <div style={{marginBottom:8}}>
              <label>
                <input
                  type="checkbox"
                  name="valid"
                  checked={form.valid === 1}
                  onChange={(e) => setForm({ ...form, valid: e.target.checked ? 1 : 0 })}
                />
                Valid (Show in Directory)
              </label>
            </div>
          </>
        ) : (
          <>
            <input name="firstName" value={form.firstName||''} onChange={handleChange} placeholder="First Name" required style={{marginBottom:8}}/><br/>
            <input name="lastName" value={form.lastName||''} onChange={handleChange} placeholder="Last Name" required style={{marginBottom:8}}/><br/>
            <input name="schoolEmail" value={form.schoolEmail||''} onChange={handleChange} placeholder="School Email" required style={{marginBottom:8}}/><br/>
            <input name="personalEmail" value={form.personalEmail||''} onChange={handleChange} placeholder="Personal Email" required style={{marginBottom:8}}/><br/>
            <input name="gradYear" value={form.gradYear||''} onChange={handleChange} placeholder="Grad Year" required style={{marginBottom:8}}/><br/>
          </>
        )}
        <div style={{marginTop:16}}>
          <button type="submit" style={{marginRight:12}}>Save</button>
          <button onClick={onClose} type="button">Cancel</button>
        </div>
      </form>
    </div>
  );
}
